;; This Source Code Form is subject to the terms of the Mozilla Public
;; License, v. 2.0. If a copy of the MPL was not distributed with this
;; file, You can obtain one at http://mozilla.org/MPL/2.0/

(ns renolit-roofing-service.view.not-found
  (:require [renolit-roofing-service.view :as view]))

(def ^:const route-config
  {:name [:not-found]})

(defn- main []
  [:div
   [:span "Not found"]])

(defmethod view/view-display (:name route-config)
  [_]
  [main])
